module.exports = __webpack_public_path__ + "static/media/success.299c092d.svg";